<template>
  <div class="scroll_wrapper" ref="wrapper">
    <div class="wrapper_main" ref="wrapper_main">
      <!-- 顶部提示信息 -->
      <div
        :class="['pulldown',height==40?'pullupD':'']"
        :style="{'top':dragTip.translate+'px'}"
      >
        <div class="clear" v-if="pulldown">
          <p :style="{'color':(textColor?textColor:'#666')}">{{dragTip.text}}</p>
        </div>
      </div>
      <div class="heaer" :style="'height:'+height+'px'" v-if="pulldown && dragTip.translate == 0"></div>
      <slot></slot>
      <!-- 底部提示信息 v-if="pullup && (data.length > 0 || Object.keys(objData).length > 0)" -->
      <div
        v-if="showBottomTips && pullup && (data.length > 0 || Object.keys(objData).length > 0)"
        :class="['pullup',height==40?'pullupD':'']"
      >
        <div class="clear">
          <p :style="{'color':(textColor?textColor:'#999')}">{{allLoaded?'没有更多了～':'加载中...'}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import BScroll from "better-scroll";
export default {
  name: "myScroll",
  props: {
    /*
     * 1 滚动的时候会派发scroll事件，会截流。
     * 2 滚动的时候实时派发scroll事件，不会截流。
     * 3 除了实时派发scroll事件，在swipe的情况下仍然能实时派发scroll事件
     */
    startX:{ type: Number, default: 0 },//横轴方向初始化位置。
    mainWidth:{ type: String, default: '100vw' },//内容的宽度
    probeType: { type: Number, default: 1 },
    allLoaded: { type: Boolean, default: false },
    // 点击列表是否派发click事件
    click: { type: Boolean, default: true },
    // 是否开启横向滚动
    scrollX: { type: Boolean, default: false },
    scrollY: { type: Boolean, default: true },
    // 是否派发滚动事件
    listenScroll: { type: Boolean, default: true },
    // 是否派发滚动到底部的事件，用于上拉加载
    pullup: { type: Boolean, default: true },
    // 是否派发顶部下拉的事件，用于下拉刷新
    pulldown: { type: Boolean, default: true },
    // 是否派发列表滚动开始的事件
    beforeScroll: { type: Boolean, default: false },
    // 当数据更新后，刷新scroll的延时。
    refreshDelay: { type: Number, default: 20 },
    // 列表数据
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    objData: {
      type: Object,
      default() {
        return {};
      }
    },
    textColor: { type: String, default: "" },
    showBottomTips:{type: Boolean, default:true}
  },
  data() {
    return {
      dragTip: {
        text: "下拉刷新",
        translate: -40,
        showLoding: false
      },
      isLoading: false,
      isDone: false,
      height: 40
    };
  },
  mounted() {
    // 保证在DOM渲染完毕后初始化better-scroll
    setTimeout(() => {
      this._initScroll();
    }, 20);
  },
  created() {
  },
  watch: {
    // 监听数据的变化，延时refreshDelay时间后调用refresh方法重新计算，保证滚动效果正常
    data() {
      setTimeout(() => {
        this.refresh();
      }, this.refreshDelay);
    },
    startX(){
      this._initScroll();
    },
    objData() {
      setTimeout(() => {
        this.refresh();
      }, this.refreshDelay);
    }
  },
  methods: {
    _initScroll() {
      if (!this.$refs.wrapper) {
        return;
      }
      if(this.scrollY){
        this.$refs.wrapper_main.style.minHeight =
        this.$refs.wrapper.clientHeight + 1 + "px";
      }else{
        this.$refs.wrapper_main.style.minWidth =
        this.mainWidth
      }
      // better-scroll的初始化
      this.scroll = new BScroll(this.$refs.wrapper, {
        startX: this.startX,
        probeType: this.probeType,
        click: this.click,
        scrollX: this.scrollX,
        scrollY:this.scrollY,
        // bounce: false// 关闭better-scroll滚动到最底部或者顶部的弹性效果
      });
      // 是否派发滚动事件
      if (this.listenScroll) {
        this.scroll.on("scroll", pos => {
          this.$emit("scroll", pos);
        });
        this.scroll.on("scrollEnd", () => {
          this.$emit("scrollEnd");
        });
      }
      // 是否派发滚动到底部事件，用于上拉加载
      if (this.pullup) {
        this.scroll.on("scrollEnd", () => {
          // 滚动到底部
          if (this.scroll.y <= this.scroll.maxScrollY + this.height) {
            // 所有数据加载完毕后
            // this.$on('infinitescroll.loadedDone', () => {
            // this.isLoading = false;
            // this.isDone = true;
            // this.finishPulling();
            // });
            // 单次请求数据加载完毕后
            // this.$on("infinitescroll.finishLoad", ret => {
            //   this.isLoading = false;
            // });
            // 重新初始化
            // this.$on("infinitescroll.reInit", () => {
            //   this.isLoading = false;
            //   this.isDone = false;
            // });
            this.dragTip.isLoading = false;
            // this.scroll.finishPullUp(); // 结束上拉加载更多
            this.$emit("loadUp");
          }
        });
      }
      // 是否派发顶部下拉事件，用于下拉刷新
      if (this.pulldown) {
        this.scroll.on("scroll", pos => {
          // 显示下拉刷新loding
          this.dragTip.showLoding = true;
          // 隐藏底部加载loding
          this.isLoading = false;
          if (pos.y > this.height) {
            this.dragTip.text = "松开刷新";
          } else {
            this.dragTip.text = "下拉刷新";
          }
        });
        this.scroll.on("touchEnd", pos => {
          if (pos.y > this.height) {
            this.dragTip.translate = 0;
            this.dragTip.text = "刷新中...";
            this.bottom_tip_text = "加载中...";
            this.$emit("pulldown", pos);
            this.resetParams();
          }
          // 重新初始化
        });
      }
      // 是否派发列表滚动开始的事件
      if (this.beforeScroll) {
        this.scroll.on("beforeScrollStart", () => {
          this.$emit("beforeScroll");
        });
      }
    },
    finishPulling() {
      this.scroll.finishPullDown(); // 结束下拉刷新
      this.scroll.finishPullUp(); // 结束上拉加载更多
      this.scroll.refresh(); // dom节点变化，重新计算better-scroll
    },
    resetParams() {
      // this.finishPulling();
      setTimeout(() => {
        this.isLoading = false;
        this.isDone = false;
        this.dragTip = {
          text: "下拉刷新",
          translate: -this.height,
          showLoding: false
        };
      }, 500);
    },
    disable() {
      // 代理better-scroll的disable方法
      this.scroll && this.scroll.disable();
    },
    enable() {
      // 代理better-scroll的enable方法
      this.scroll && this.scroll.enable();
    },
    refresh() {
      // 代理better-scroll的refresh方法
      this.scroll && this.scroll.refresh();
    },
    scrollTo() {
      // 代理better-scroll的scrollTo方法
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments);
    },
    scrollToElement() {
      // 代理better-scroll的scrollToElement方法
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments);
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common.less";
.scroll_wrapper {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
/* 下拉刷新 */
.pulldown,
.pullup {
  width: 100%;
  height: 40px;
  position: relative;
  .clear {
    font-size: 0.28rem;
    width: 100%;
    text-align: center;
    line-height: 40px;
    color: #666;
  }
}
.pullupD {
  height: 40px;
  .clear {
    line-height: 40px;
  }
}
.pulldown {
}
.wrapper_main {
  position: relative;
  border-top: 1px solid transparent;
}
.pulldown {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
</style>
